import { type TReply as TApiReply } from '@core/api'

import { type TReply } from '@core/models'

import { convertCommenter } from './convertCommenter'

export const convertReply = (apiReply: TApiReply): TReply => {
    const {
        commenter,
        content,
        date_created,
        date_updated,
        id,
        parent_id,
        replies_count,
        thread_id,
    } = apiReply

    return {
        commenter: convertCommenter(commenter),
        content,
        dateCreated: date_created,
        dateUpdated: date_updated,
        id,
        parentId: parent_id,
        repliesCount: replies_count,
        threadId: thread_id,
    }
}
